import React, { useContext } from "react";
import Sidebar from "../components/Sidebar";
import Typography from "@material-ui/core/Typography";
import { AuthContext } from "../context/AuthContext";
import bg from "../assets/images/marketing.jpg";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";

const useStyle = makeStyles({
  margin_wrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  box: {
    flex: 1,
    margin: 20,
    padding: 20,
    background: "#00824A",
    color: "#fff",
  },
});

const Home = () => {
  const classes = useStyle();

  const { auth } = useContext(AuthContext);
  return (
    <div className="wrapper">
      <Sidebar />
      <div className="wrapper-inner">
        <div className="" style={{}}>
          <Typography variant="h4" style={{ textAlign: "center", padding: 20 }}>
            <div className={classes.margin_wrapper}>
              <Link to="/promotion-list" className={classes.box}>
                <div>
                  <h3>Promotion</h3>
                </div>
              </Link>
              <Link to="/notification-list" className={classes.box}>
                <div>
                  <h3>Notification</h3>
                </div>
              </Link>
              <Link to="/view-role" className={classes.box}>
                <div className="box">
                  <h3>View Roles</h3>
                </div>
              </Link>
            </div>
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default Home;
